import { type FC, memo } from "react";
import { NavLink } from "react-router-dom";
import { Icon } from "../../ui";
import { type NavItemProp } from "./AdminSidebar.types";
import styles from "./AdminSidebar.module.scss";
import clsx from "clsx";

const NavItem: FC<NavItemProp> = memo(({ item, isActive }) => {
  return (
    <NavLink
      to={item.href}
      className={clsx(styles["nav-item"], {
        [styles.active]: isActive, // ✅ Apply active class
      })}
    >
      {/** Default Icon */}
      <Icon
        name={item.icon}
        size={20}
        // className={styles["icon icon-default"]}
        className={clsx(styles.icon, styles.iconDefault)}
      />
      {/* Hover Icon */}
      <Icon
        name={item.iconHover}
        size={20}
        // className={styles["icon icon-hover"]}
        className={clsx(styles.icon, styles.iconHover)}
      />

      <span className={styles.navLabel}>{item.label}</span>
    </NavLink>
  );
});

NavItem.displayName = "AdminNavItem";

export default NavItem;
